import { render } from "./FloatingBtns.vue?vue&type=template&id=c38e8400"
import script from "./FloatingBtns.vue?vue&type=script&lang=js"
export * from "./FloatingBtns.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__